import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { CommentsBlock } from '../../_blocks/Comments/CommentsBlock';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock } from '../../types/api/Block';

export type CommentsWidgetProps = WidgetShape<[CommentsBlock], WidgetType.comments>;

export function CommentsWidget({ blocks, ...headerProps }: CommentsWidgetProps) {
  const { t } = useSonTranslation('CommentsBlock');

  if (isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={WidgetType.comments}
      icon={Icons.COMMENTS}
      title={t('widgetTitle')}
    >
      {blocks[0] && <CommentsBlock {...blocks[0]} />}
    </DefaultWidgetWithHeader>
  );
}
